<template>
    <div class="pageDiv">


        <v-card class="main-card">

            <v-card-title>
                <span class="page-title">{{ $AuthSvc.getYear() }} Fun Tournaments</span>
            </v-card-title>

            <v-card-text v-if="tournaments.length === 0">
              <span class="label14">
                  No fun tournaments scheduled at this time.
              </span>
            </v-card-text>

            <div class="schedule-card-div"
              v-for="tournament in tournaments" :key="tournament.tournamentId" >
                <v-card class="schedule-card">
                    <v-img class="course-img" :aspect-ratio="16/9"
                           :src="'/images/courses/' + tournament.course.image">
                    </v-img>

                    <v-card-text>
                        <br/>
                        <v-card-text class="name-card" v-if="tournament.tournament.sponsorName===null || tournament.tournament.sponsorName===''">
                          <span class="label18">
                              {{tournament.course.name}}
                              <div class="major-logo" v-if="tournament.tournament.major==='Y'">
                                  <v-img src="../../assets/img/dfwvga-logo-black-mini.png">
                                  </v-img>
                              </div>
                          </span>
                        </v-card-text>

                        <v-card-text class="name-card" v-if="tournament.tournament.sponsorName!==null && tournament.tournament.sponsorName!==''">
                            <v-card-text>
                                <v-card-text>
                              <span class="label18">
                                  {{tournament.tournament.sponsorName}}
                              </span>
                                  <span class="major-logo" v-if="tournament.tournament.major==='Y'">
                                  <v-img src="../../assets/img/dfwvga-logo-mini.png">
                                  </v-img>
                              </span>
                                </v-card-text>
                            </v-card-text>
                            <span class="label14">
                              {{tournament.course.name}}</span>
                          </span>
                        </v-card-text>
                    </v-card-text>

                    <v-card-actions class="card-action">
                        <span style="font-weight:bold;font-size:20px !important">{{printMonth(tournament.tournament.scheduleDate)}}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="tournament.tournament.status === 'REGISTER'"
                          class="action-button register"
                          @click="register(tournament)">
                            Register Now
                        </v-btn>
                        <v-btn v-if="tournament.tournament.status === 'REGISTER_COMPLETED'"
                               class="status-button results">
                            Generating Group
                        </v-btn>
                        <v-btn
                          v-if="tournament.tournament.status === 'GROUPING'"
                          class="action-button register-complete"
                          @click="pairing(tournament)">
                            Pairings
                        </v-btn>
                        <v-btn
                          v-if="tournament.tournament.status === 'ACTIVE'"
                          class="action-button results"
                          @click="scoreCard(tournament)">
                            Score Card
                        </v-btn>
                        <v-btn v-if="tournament.tournament.status === 'REVIEW'"
                               class="status-button results">
                            In Review
                        </v-btn>
                        <v-btn
                          v-if="tournament.tournament.status === 'OFFICIAL'"
                          class="action-button results"
                          @click="showResults(tournament)">
                            Results
                        </v-btn>
                    </v-card-actions>

                    <v-card-subtitle>
                        <b>Date: </b> {{printDate(tournament.tournament.scheduleDate)}}<br>
                        <b>Time: </b> {{printTime(tournament.tournament.scheduleDate)}} <span v-if="tournament.tournament.shotgun">SHOTGUN</span><br>
                        <b>Deadline: </b> {{printDateTime(tournament.tournament.registrationDeadline)}}<br>
                        <b>Member Fee: </b> ${{tournament.tournament.memberFee}}<br>
                        <b>Guest Fee: </b> ${{tournament.tournament.guestFee}}<br>
                        <b>Location: </b><br/> {{tournament.course.location}}<br>
                        <b>Website: </b><br/> <a @click="goTo(tournament)">{{tournament.course.website}}</a><br>
                        <span v-if="tournament.tournament.hole19!==null && tournament.tournament.hole19!==''">
                        <b>19th Hole: </b> {{tournament.tournament.hole19}}
                    </span>
                    </v-card-subtitle>
                </v-card>
            </div>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';

  export default {
    name: "schedule",
    data: () => ({
      courses: [],
      tournaments: []
    }),
    mounted: function() {
        var _this = this;
        _this.loadSchedule();
    },
    methods: {
      printMonth(date) {
        return moment(date).format('MMMM');
      },
      printDate(date) {
        return moment(date).format('ddd MMMM DD YYYY');
      },
      printTime(date) {
        return moment(date).format('hh:mm A');
      },
      printDateTime(date) {
        return moment(date).format('MMMM DD hh:mm A');
      },
      register(tournament) {
        window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
        window.location.href = '/registration';
      },
      pairing(tournament) {
        window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
        window.location.href = '/grouping';
      },
      scoreCard(tournament) {
        window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
        window.location.href = '/scoring';
      },
      showResults(tournament) {
        window.sessionStorage.setItem('selectTournament', JSON.stringify(tournament));
        window.location.href = '/results?id='+tournament.tournamentId;
      },
      goTo(tournament) {
        window.location.href = tournament.course.website;
      },
      loadSchedule() {
        var _this = this;

        _this.axios.get('/public/tournaments/type/FUN')
        .then(function (response) {
            _this.tournaments = response.data;
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      }
    }
  }
</script>

<style scoped>

  .schedule-card-div {
    margin: 10px 0;
    float: left;
    width: 100%;
  }

  .schedule-card {
    padding: 10px;
    border: 3px #1F0404 solid;
    border-radius: 10px !important;
  }

  .course-img {
    border-radius: 5px;
  }

  .card-action {
    height: 0px;
  }

  .major-logo {
    width: 30px;
    height:45px;
    margin-left: 15px;
  }

  .action-button {
    font-weight: bold;
    font-size:12px !important;
    background-color: darkgreen !important;
    color: white !important;
    height: 26px;
  }

  .status-button {
    font-weight: bold;
    font-size:12px !important;
    background-color: cyan !important;
    color: black !important;
    height: 26px;
  }

  .register {
    background-color: darkgreen !important;
  }

  .register-complete {
    background-color: green !important;
  }

  .results {
    background-color: darkred !important;
  }

  @media (min-width: 768px) {
    .v-card__text {
      font-size: 12px;
    }

    .schedule-card-div {
      margin: 10px;
      width: 400px;
    }
  }

</style>